import React, { useEffect, useState } from 'react';
import { withMotionMax } from '@hoc/withMotionMax';
import SiteWide from '@stories/Components/Global/SiteWide/SiteWide';
import { imageUrl } from '@helpers/image';
import S from './NavigationDropdown.styles';
const NavigationItem = ({ description, bgImage, external, isActive = false, tabIndex = 0, text, url, children, selected, onActive, onInactive, }) => {
    return (React.createElement(S.Item, { onMouseEnter: () => {
            onActive && onActive();
        } },
        React.createElement(S.Link, { href: url, isActive: isActive, isExternal: external ? true : false, tabIndex: tabIndex, hasImage: bgImage ? true : false, target: external ? '_blank' : '_self', title: text, onKeyDown: (event) => {
                if (event.key.toLowerCase() === 'arrowright') {
                    event.preventDefault();
                    onActive && onActive();
                }
                if (event.key.toLowerCase() === 'arrowleft') {
                    event.preventDefault();
                    onInactive && onInactive();
                }
                if (event.key.toLowerCase() === 'escape') {
                    event.preventDefault();
                    onInactive && onInactive();
                }
            } },
            bgImage && (React.createElement(S.BgImageHolder, null,
                React.createElement(S.BgImage, { alt: '', draggable: false, loading: "lazy", role: "presentation", src: imageUrl(bgImage, {}), sizes: [`25vw`].join(', '), srcSet: [
                        `${imageUrl(bgImage, { width: 789 })} 789w`,
                    ].join(', ') }))),
            React.createElement(S.ContentHolder, null,
                React.createElement(S.Arrow, null),
                React.createElement(S.LinkTitle, null, text),
                description && React.createElement(S.LinkDescription, null, description)),
            children && React.createElement(S.Chevron, null),
            selected && React.createElement(S.Chevron, null),
            external && React.createElement(S.External, null))));
};
const NavigationDropdown = ({ areaTitle, areaUrl, isActive, items = [], selected = [], mode, }) => {
    const [activeLevel1Id, setActiveLevel1Id] = useState('');
    const [activeLevel2Id, setActiveLevel2Id] = useState('');
    const [activeLevel3Id, setActiveLevel3Id] = useState('');
    const [activeLevel4Id, setActiveLevel4Id] = useState('');
    // Get the active item for each level.
    const level1Item = items && items.find((item) => item.id === activeLevel1Id);
    // const level2Item = level1Item?.children?.find((item) => item.id === activeLevel2Id);
    // const level3Item = level2Item?.children?.find((item) => item.id === activeLevel3Id);
    // Get the promo from the lowest level active item.
    // const activePromo = level2Item?.promo ?? level1Item?.promo ?? defaultPromo;
    // Reset active selection when dropdown is hidden.
    useEffect(() => {
        if (!isActive) {
            setActiveLevel1Id('');
            setActiveLevel2Id('');
            setActiveLevel3Id('');
            setActiveLevel4Id('');
        }
    }, [isActive]);
    return (React.createElement(S.Container, { mode: mode, initial: 'closed', animate: isActive ? 'opened' : 'closed', variants: {
            closed: {
                opacity: 0,
                transitionEnd: {
                    visibility: 'hidden',
                },
                transition: {
                    type: 'tween',
                    ease: 'easeOut',
                },
            },
            opened: {
                opacity: 1,
                visibility: 'visible',
                transition: {
                    type: 'tween',
                    ease: 'easeOut',
                },
            },
        }, onKeyDown: (event) => {
            if (event.key.toLowerCase() === 'escape') {
                if (activeLevel2Id) {
                    event.preventDefault();
                    event.stopPropagation();
                    setActiveLevel2Id('');
                    return;
                }
                if (activeLevel1Id) {
                    event.preventDefault();
                    event.stopPropagation();
                    setActiveLevel1Id('');
                    return;
                }
            }
        } },
        React.createElement(SiteWide, null,
            React.createElement(S.DropDownTop, null,
                React.createElement(S.AreaLink, { href: areaUrl, key: areaUrl, title: areaTitle }, areaTitle)),
            React.createElement(S.Inner, null,
                renderColumn1(),
                renderColumn2(),
                renderColumn3(),
                renderColumn4(),
                renderColumnCard(),
                renderColumnSelected()))));
    function renderColumn1() {
        return (React.createElement(S.Column1, null,
            React.createElement(S.List, null, items && items.map((item) => (React.createElement(NavigationItem, { key: item.id, ...item, isActive: activeLevel1Id === item.id, tabIndex: isActive && (!activeLevel1Id || activeLevel1Id === item.id) ? 0 : -1, onActive: () => {
                    setActiveLevel1Id(item.id);
                    setActiveLevel2Id('');
                    setActiveLevel3Id('');
                    setActiveLevel4Id('');
                }, onInactive: () => {
                    setActiveLevel1Id('');
                    setActiveLevel2Id('');
                    setActiveLevel3Id('');
                    setActiveLevel4Id('');
                } }))))));
    }
    function renderColumn2() {
        return items && items.map((item) => {
            const isActive = activeLevel1Id === item.id;
            return (React.createElement(React.Fragment, null,
                item.children &&
                    React.createElement(S.Column2, { key: item.id, isActive: isActive, initial: 'closed', animate: isActive ? 'opened' : 'closed', variants: {
                            closed: {
                                opacity: 0,
                                transitionEnd: {
                                    visibility: 'hidden',
                                },
                                transition: {
                                    type: 'tween',
                                    ease: 'easeOut',
                                },
                            },
                            opened: {
                                opacity: 1,
                                visibility: 'visible',
                                transition: {
                                    type: 'tween',
                                    ease: 'easeOut',
                                },
                            },
                        } },
                        React.createElement(S.List, null, item.children.map((child) => (React.createElement(NavigationItem, { key: child.id, ...child, isActive: activeLevel2Id === child.id, tabIndex: activeLevel1Id === item.id && (!activeLevel2Id || activeLevel2Id === child.id)
                                ? 0
                                : -1, onActive: () => {
                                setActiveLevel2Id(child.id);
                                setActiveLevel3Id('');
                                setActiveLevel4Id('');
                            }, onInactive: () => {
                                setActiveLevel2Id('');
                                setActiveLevel3Id('');
                                setActiveLevel4Id('');
                            } }))))),
                item.selected && item.selected.length > 0 &&
                    React.createElement(S.ColumnSelected, { isActive: isActive ?? false, initial: 'opened', animate: isActive ? 'opened' : 'closed', variants: {
                            closed: {
                                opacity: 0,
                                transitionEnd: {
                                    visibility: 'hidden',
                                },
                                transition: {
                                    type: 'tween',
                                    ease: 'easeOut',
                                },
                            },
                            opened: {
                                opacity: 1,
                                visibility: 'visible',
                                transition: {
                                    type: 'tween',
                                    ease: 'easeOut',
                                },
                            },
                        } },
                        React.createElement(S.List, null, item.selected.map((item) => (React.createElement(NavigationItem, { key: item.id, ...item, isActive: activeLevel2Id === item.id, tabIndex: isActive && (!activeLevel2Id || activeLevel2Id === item.id) ? 0 : -1 })))))));
        });
    }
    function renderColumn3() {
        return items && items.map((item) => item?.children?.map((third) => {
            if (!third.children) {
                return null;
            }
            const isActive = activeLevel2Id === third.id;
            return (React.createElement(S.Column3, { key: third.id, isActive: isActive ?? false, initial: 'closed', animate: isActive ? 'opened' : 'closed', variants: {
                    closed: {
                        opacity: 0,
                        transitionEnd: {
                            visibility: 'hidden',
                        },
                        transition: {
                            type: 'tween',
                            ease: 'easeOut',
                        },
                    },
                    opened: {
                        opacity: 1,
                        visibility: 'visible',
                        transition: {
                            type: 'tween',
                            ease: 'easeOut',
                        },
                    },
                } },
                React.createElement(S.List, null, third.children.map((child) => (React.createElement(NavigationItem, { key: child.id, ...child, isActive: activeLevel3Id === child.id, tabIndex: activeLevel2Id === item.id && (!activeLevel3Id || activeLevel3Id === child.id)
                        ? 0
                        : -1, onActive: () => {
                        setActiveLevel3Id(child.id);
                        setActiveLevel4Id('');
                    }, onInactive: () => {
                        setActiveLevel3Id('');
                        setActiveLevel4Id('');
                    } }))))));
        }));
    }
    function renderColumn4() {
        return items && items.map((item) => item?.children?.map((third) => third?.children?.map((fourth) => {
            if (!fourth.children) {
                return null;
            }
            const isActive = activeLevel3Id === fourth.id;
            return (React.createElement(S.Column4, { key: fourth.id, isActive: isActive ?? false, initial: 'closed', animate: isActive ? 'opened' : 'closed', variants: {
                    closed: {
                        opacity: 0,
                        transitionEnd: {
                            visibility: 'hidden',
                        },
                        transition: {
                            type: 'tween',
                            ease: 'easeOut',
                        },
                    },
                    opened: {
                        opacity: 1,
                        visibility: 'visible',
                        transition: {
                            type: 'tween',
                            ease: 'easeOut',
                        },
                    },
                } },
                React.createElement(S.List, null, fourth.children.map((child) => (React.createElement(NavigationItem, { key: child.id, ...child, isActive: activeLevel4Id === child.id, tabIndex: activeLevel3Id === item.id && (!activeLevel4Id || activeLevel4Id === child.id)
                        ? 0
                        : -1, onActive: () => {
                        setActiveLevel4Id(child.id);
                    }, onInactive: () => {
                        setActiveLevel4Id('');
                    } }))))));
        })));
    }
    function renderColumnCard() {
        return items && items.map((item) => item?.children?.map((third) => {
            if (mode !== 1) {
                return null;
            }
            const showFirst = level1Item?.children ? level1Item?.children[0].id : false;
            const isActive = activeLevel2Id ? activeLevel2Id === third.id : showFirst === third.id;
            return (React.createElement(S.ColumnCard, { key: third.id, isActive: isActive, initial: 'closed', animate: isActive ? 'opened' : 'closed', variants: {
                    closed: {
                        opacity: 0,
                        transitionEnd: {
                            visibility: 'hidden',
                        },
                        transition: {
                            type: 'tween',
                            ease: 'easeOut',
                        },
                    },
                    opened: {
                        opacity: 1,
                        visibility: 'visible',
                        transition: {
                            type: 'tween',
                            ease: 'easeOut',
                        },
                    },
                } },
                React.createElement(S.List, null,
                    React.createElement(NavigationItem, { ...third, isActive: activeLevel2Id === third.id, tabIndex: activeLevel1Id === item.id && (!activeLevel2Id || activeLevel2Id === third.id)
                            ? 0
                            : -1 }))));
        }));
    }
    function renderColumnSelected() {
        if (mode !== 2) {
            return null;
        }
        return (React.createElement(S.ColumnSelected, { isActive: isActive ?? false, initial: 'opened', animate: isActive ? 'opened' : 'closed', variants: {
                closed: {
                    opacity: 0,
                    transitionEnd: {
                        visibility: 'hidden',
                    },
                    transition: {
                        type: 'tween',
                        ease: 'easeOut',
                    },
                },
                opened: {
                    opacity: 1,
                    visibility: 'visible',
                    transition: {
                        type: 'tween',
                        ease: 'easeOut',
                    },
                },
            } },
            React.createElement(S.List, null, selected && selected.map((item) => (React.createElement(NavigationItem, { key: item.id, ...item, isActive: activeLevel1Id === item.id, tabIndex: isActive && (!activeLevel1Id || activeLevel1Id === item.id) ? 0 : -1 }))))));
    }
};
export default withMotionMax(NavigationDropdown);
